import styled from 'styled-components';
import { ButtonStyled } from '@fundacao/shared-components/esm/ie';

export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const PaginacaoContainer = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: row;
  align-items: center;

  > span {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    color: #7a8799;
    margin-right: 20px;
  }

  > * {
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const RoundedButton = styled(ButtonStyled)`
  min-width: 40px;
  width: 40px;
  height: 40px !important;
  border-radius: 50%;
  padding: 0 !important;
  margin-bottom: 0 !important;
`;
